import React from "react";

import Pagination, { PaginationInterface } from "../Pagination";
import { Table as TableAntd, TableProps } from "antd";
import './style.scss';

interface TableInterface {
  loading?: TableProps<any>['loading'];
  rowKey: TableProps<any>['rowKey'];
  columns: TableProps<any>['columns'];
  dataSource: TableProps<any>['dataSource'];
  expandable?: TableProps<any>['expandable'];
  rowSelection?: TableProps<any>['rowSelection'];
  pagination?: PaginationInterface;
}

const Table = (
  { loading, columns, dataSource, expandable, pagination, rowSelection, rowKey = 'id'}: TableInterface
) => {
  return (
    <>
      <TableAntd
        className='v-table'
        rowKey={rowKey}
        loading={loading}
        columns={columns}
        rowSelection={rowSelection}
        dataSource={dataSource}
        pagination={false}
        expandable={expandable}
      />

      {pagination && <Pagination {...pagination} />}
    </>
  )
}

Table.EXPAND_COLUMN = TableAntd.EXPAND_COLUMN;

export default Table;
